import template from './component.tpl.html';

class SchuetzenFestzeltQuotaStatsController {
    constructor(http, scope, env) {
        this.http = http;
        this.scope = scope;
        this.env = env;
        this.resetState();
        this.init();
    }

    init() {
        this.initWatchers();
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.guestlistId;
        }, (newVal) => {
            this.updateData();
        });
    }

    updateData() {
        this.resetState();
        if (!this.guestlistId) {
            this.loading = false;
            return;
        }

        this.http.get('oktoberfest/statistics/guestlists/' + this.guestlistId + '/quotas').then((response) => {
            this.loading = false;
            _.each(response.data.data, (row) => {
               if(!this.data[row.area.id]) {
                   this.data[row.area.id] = {
                       'label': row.area.label,
                       'options': []
                   }
               }

                this.data[row.area.id].options.push(row);
            });

            console.log(this.data);
            this.applyAsync();
        }, () => {
            this.loading = false;
            this.error = true;
        });
    }

    applyAsync() {
        this.scope.$evalAsync();
    }

    resetState() {
        this.data = {};
    }
}

SchuetzenFestzeltQuotaStatsController.$inject = [
    '$http',
    '$scope',
    'Env'
];

angular.module('festzelt-os.components.stats')
    .component('schuetzenFestzeltQuotaStats', {
        bindings: {
            'guestlistId': '<'
        },
        controller: SchuetzenFestzeltQuotaStatsController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/stats/components/guestlists/schuetzenfestzelt-quotas/component.js